export default {
    beforeResendCode: 60, // 1 min
};
